export enum InsuranceType {
  PRIVATE = 'pkv',
  PUBLIC = 'gkv'
}

// custom type guard
export function isValidInsuranceType(value: string): value is InsuranceType {
  return Object.values(InsuranceType).includes(value as InsuranceType);
}
